import { AxiosInstance } from "axios";

export const SousFenetreService = {

  enableSousFenetre: async (api: AxiosInstance, id: number): Promise<number> => {
    try {
      const response = await api.put(`/sous-fenetre-management/enable/${id}`);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de l'activation de la sous-fenêtre ${id}:`, error);
      if (error.response?.data) throw new Error(error.response.data);
      throw error;
    }
  },

  disableSousFenetre: async (api: AxiosInstance, id: number): Promise<number> => {
    try {
      const response = await api.put(`/sous-fenetre-management/disable/${id}`);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de la désactivation de la sous-fenêtre ${id}:`, error);
      if (error.response?.data) throw new Error(error.response.data);
      throw error;
    }
  }

};
